/* choose-your-glow.js — simplified checkout for CTAs */
(() => {
  const inflight = new WeakSet();
  let currentAlert = null;

  function createErrorAlert(message, cta) {
    // Remove existing alert if any
    removeErrorAlert();
    
    // Create alert element
    const alert = document.createElement('div');
    alert.className = 'proplus-error-alert';
    alert.style.cssText = `
      position: absolute;
      top: -60px;
      left: 0;
      right: 0;
      background: #fee2e2;
      border: 1px solid #fecaca;
      color: #dc2626;
      padding: 12px;
      border-radius: 6px;
      font-size: 14px;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
      z-index: 1000;
      animation: slideDown 0.3s ease-out;
    `;
    alert.innerHTML = `
      <div style="display: flex; justify-content: space-between; align-items: flex-start;">
        <span>${message}</span>
        <button onclick="this.parentElement.parentElement.remove(); window.currentProPlusAlert = null;" 
                style="background: none; border: none; color: #dc2626; font-size: 16px; cursor: pointer; padding: 0; margin-left: 8px;">×</button>
      </div>
    `;
    
    // Add CSS animation
    if (!document.querySelector('#proplus-alert-styles')) {
      const style = document.createElement('style');
      style.id = 'proplus-alert-styles';
      style.textContent = `
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .proplus-error-alert:hover {
          background: #fef2f2;
        }
      `;
      document.head.appendChild(style);
    }
    
    // Position relative to button
    const ctaContainer = cta.closest('.cyg-cta') || cta.parentElement;
    if (ctaContainer) {
      ctaContainer.style.position = 'relative';
      ctaContainer.appendChild(alert);
    }
    
    currentAlert = alert;
    window.currentProPlusAlert = alert;
    
    // Auto-remove after 5 seconds
    setTimeout(() => {
      removeErrorAlert();
    }, 5000);
    
    // Click outside to remove
    const clickOutsideHandler = (e) => {
      if (alert && !alert.contains(e.target) && !cta.contains(e.target)) {
        removeErrorAlert();
        document.removeEventListener('click', clickOutsideHandler);
      }
    };
    
    // Add event listener after a short delay to avoid immediate closure
    setTimeout(() => {
      document.addEventListener('click', clickOutsideHandler);
    }, 100);
    
    return alert;
  }

  function removeErrorAlert() {
    if (currentAlert) {
      currentAlert.remove();
      currentAlert = null;
      window.currentProPlusAlert = null;
    }
  }

  async function getProductInfoByVariant(variantId) {
    try {
      // For the specific variant ID from your data
      if (variantId === '42254728495194') {
        return 'Sonicsmooth Pro+ Complete Glow';
      }
      
      // Try to fetch from the specific product API endpoint
      const productResponse = await fetch(`/products/sonicsmooth-pro-complete-glow.js`);
      if (productResponse.ok) {
        const product = await productResponse.json();
        const variant = product.variants.find(v => v.id.toString() === variantId.toString());
        if (variant) {
          return product.title;
        }
      }
      
      // Fallback: try other common product handles
      const commonHandles = [
        'sonicsmooth-basic',
        'sonicsmooth-pro-upgrade',
        'sonicsmooth-complete-bundle'
      ];
      
      for (const handle of commonHandles) {
        try {
          const response = await fetch(`/products/${handle}.js`);
          if (response.ok) {
            const product = await response.json();
            const variant = product.variants.find(v => v.id.toString() === variantId.toString());
            if (variant) {
              return product.title;
            }
          }
        } catch (e) {
          continue;
        }
      }
      
      return `Product (ID: ${variantId})`;
    } catch (error) {
      console.error('Error fetching product info:', error);
      return `Product (ID: ${variantId})`;
    }
  }

  async function analyzeCartForBundleInfo(variantIds) {
    try {
      // Get current cart data to analyze bundle structure
      const cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      
      if (!cartResponse.ok) return null;
      
      const cartData = await cartResponse.json();
      console.log('[ProPlus CTA] Cart data for bundle analysis:', cartData);
      
      const bundleInfo = {
        isBundleParent: false,
        bundleTitle: null,
        components: []
      };
      
      // Look for bundle parent items
      cartData.items.forEach(item => {
        if (variantIds.includes(item.variant_id.toString())) {
          if (item.bundle_parent) {
            bundleInfo.isBundleParent = true;
            bundleInfo.bundleTitle = item.product_title;
            
            // Get bundle components if available
            if (item.bundle_components && Array.isArray(item.bundle_components)) {
              bundleInfo.components = item.bundle_components.map(component => ({
                title: component.product_title || component.title,
                quantity: component.quantity,
                variantTitle: component.variant_title !== 'Default Title' ? component.variant_title : null
              }));
            }
          }
        }
      });
      
      return bundleInfo;
    } catch (error) {
      console.error('[ProPlus CTA] Error analyzing cart for bundle info:', error);
      return null;
    }
  }

  async function getUnavailableProducts(variantIds, errorText) {
    // First try to get bundle info from cart if items were added
    const bundleInfo = await analyzeCartForBundleInfo(variantIds);
    
    if (bundleInfo && bundleInfo.isBundleParent && bundleInfo.components.length > 0) {
      // If it's a bundle, try to identify which components failed
      console.log('[ProPlus CTA] Bundle detected, analyzing components...');
      
      // Parse error text for component names
      const componentNames = bundleInfo.components.map(comp => comp.title);
      const failedComponents = [];
      
      componentNames.forEach(compName => {
        if (errorText.includes(compName) || errorText.includes('sold out') || errorText.includes('unavailable')) {
          failedComponents.push(compName);
        }
      });
      
      if (failedComponents.length > 0) {
        return failedComponents;
      } else {
        // If we can't identify specific components, return all
        return componentNames;
      }
    }
    
    // Fallback: try to parse Shopify error for product names
    const patterns = [
      /The product '([^']+)' is sold out/,
      /'([^']+)' is not available/,
      /([^']+) is out of stock/,
      /Product '([^']+)' cannot be added/
    ];
    
    for (const pattern of patterns) {
      const match = errorText.match(pattern);
      if (match) {
        return [match[1]];
      }
    }
    
    // Final fallback: fetch product names for each variant
    const productNames = [];
    for (const variantId of variantIds) {
      const productName = await getProductInfoByVariant(variantId);
      productNames.push(productName);
    }
    
    return productNames;
  }

  function getVariantIds(el) {
    const variantIds = [];
    
    // Check for multiple variant IDs (for bundles)
    const variantList = (el.getAttribute('data-variant-ids') || '').trim();
    if (variantList) {
      const ids = variantList.split(',').map(id => id.trim().replace(/[^\d]/g, '')).filter(id => id && parseInt(id) > 0);
      variantIds.push(...ids);
    }
    
    // Check for single variant ID
    const singleVariant = (el.getAttribute('data-variant-id') || '').trim();
    if (singleVariant && !variantIds.length) {
      const cleanId = singleVariant.replace(/[^\d]/g, '');
      if (cleanId && parseInt(cleanId) > 0) {
        variantIds.push(cleanId);
      }
    }
    
    return variantIds.length > 0 ? variantIds : null;
  }

  window.addEventListener(
    'click',
    async (e) => {
      const cta = e.target && e.target.closest && e.target.closest('[data-proplus-cta]');
      if (!cta) return;

      console.log('[ProPlus CTA] Button clicked');
      
      const variantIds = getVariantIds(cta);
      console.log('[ProPlus CTA] Variant IDs:', variantIds);
      
      // If no variant IDs, allow normal navigation
      if (!variantIds) {
        console.log('[ProPlus CTA] No variant IDs, allowing normal navigation');
        const href = cta.getAttribute('href');
        if (!href || href === '#') {
          e.preventDefault();
          alert('Please configure a product in the section settings');
        }
        return;
      }

      // Prevent default and handle cart operation
      e.preventDefault();
      e.stopImmediatePropagation();
      
      if (inflight.has(cta)) return;
      inflight.add(cta);

      const originalText = cta.textContent;
      cta.textContent = 'ADDING TO CART...';
      cta.setAttribute('disabled', 'true');

      try {
        console.log('[ProPlus CTA] Adding variants to cart:', variantIds);
        
        // Clear cart first to avoid conflicts
        console.log('[ProPlus CTA] Clearing cart first...');
        try {
          await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin'
          });
          console.log('[ProPlus CTA] Cart cleared successfully');
        } catch (clearErr) {
          console.log('[ProPlus CTA] Cart clear failed, continuing anyway:', clearErr);
        }
        
        // For single variant (including Bundle Builder bundles), use simple add
        // For multiple variants (legacy custom bundles), use items array
        let addResponse;
        if (variantIds.length === 1) {
          const variantId = parseInt(variantIds[0]);
          console.log('[ProPlus CTA] Adding single variant/bundle:', variantId);
          console.log('[ProPlus CTA] Variant ID type check:', typeof variantId, 'isNaN:', isNaN(variantId));
          
          addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });
        } else {
          console.log('[ProPlus CTA] Adding multiple variants as custom bundle:', variantIds);
          const items = variantIds.map(id => ({ id: parseInt(id), quantity: 1 }));
          addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify({ items })
          });
        }

        if (!addResponse.ok) {
          const errorText = await addResponse.text();
          console.error('[ProPlus CTA] Cart add error response:', errorText);
          console.error('[ProPlus CTA] Response status:', addResponse.status);
          console.error('[ProPlus CTA] Response headers:', Object.fromEntries(addResponse.headers.entries()));
          
          // Check for sold out error
          if (addResponse.status === 422 || errorText.includes('sold out') || errorText.includes('unavailable') || errorText.includes('inventory')) {
            // Get specific product names
            console.log('[ProPlus CTA] Getting product names for unavailable items...');
            const unavailableProducts = await getUnavailableProducts(variantIds, errorText);
            
            let errorMessage;
            if (unavailableProducts.length === 1) {
              errorMessage = `❌ <strong>${unavailableProducts[0]}</strong> is currently sold out`;
            } else if (unavailableProducts.length > 1) {
              errorMessage = `❌ The following products are currently sold out:<br>`;
              unavailableProducts.forEach(product => {
                errorMessage += `• <strong>${product}</strong><br>`;
              });
            } else {
              // Fallback message
              errorMessage = variantIds.length === 1 ? 
                '❌ This product is currently sold out' : 
                '❌ Some products in this bundle are unavailable';
            }
            
            console.log('[ProPlus CTA] Unavailable products:', unavailableProducts);
            
            // Show detailed error alert
            createErrorAlert(errorMessage, cta);
            
            // Show sold out error on button
            cta.textContent = unavailableProducts.length > 1 ? 'SOME ITEMS SOLD OUT' : 'SOLD OUT';
            cta.style.backgroundColor = '#dc2626';
            cta.style.color = 'white';
            cta.removeAttribute('disabled');
            inflight.delete(cta);
            
            // Reset button after 3 seconds
            setTimeout(() => {
              cta.textContent = originalText;
              cta.style.backgroundColor = '';
              cta.style.color = '';
            }, 3000);
            
            return; // Don't proceed to checkout
          }
          
          throw new Error(`Cart add failed: ${addResponse.status} - ${errorText}`);
        }

        const addResult = await addResponse.json();
        console.log('[ProPlus CTA] Cart add successful:', addResult);

        // Check for partial failures in bundle adds
        if (addResult && typeof addResult === 'object') {
          if (addResult.errors && Object.keys(addResult.errors).length > 0) {
            console.error('[ProPlus CTA] Cart add had errors:', addResult.errors);
            
            // Build detailed error message
            const errorKeys = Object.keys(addResult.errors);
            let errorMessage = '❌ Some items are unavailable:';
            errorKeys.forEach(key => {
              const error = addResult.errors[key];
              if (typeof error === 'string') {
                errorMessage += `<br>• ${error}`;
              } else if (Array.isArray(error)) {
                error.forEach(err => {
                  errorMessage += `<br>• ${err}`;
                });
              }
            });
            
            // Show detailed error alert
            createErrorAlert(errorMessage, cta);
            
            // Show error on button
            cta.textContent = 'SOME ITEMS UNAVAILABLE';
            cta.style.backgroundColor = '#dc2626';
            cta.style.color = 'white';
            cta.removeAttribute('disabled');
            inflight.delete(cta);
            
            // Reset button after 3 seconds
            setTimeout(() => {
              cta.textContent = originalText;
              cta.style.backgroundColor = '';
              cta.style.color = '';
            }, 3000);
            
            return; // Don't proceed to checkout
          }
        }

        // Verify cart has items
        console.log('[ProPlus CTA] Verifying cart contents...');
        const cartResponse = await fetch('/cart.js', {
          credentials: 'same-origin',
          cache: 'no-store'
        });
        const cartData = await cartResponse.json();
        console.log('[ProPlus CTA] Cart verification:', cartData);

        if (!cartData.items || cartData.items.length === 0) {
          // Show detailed error alert
          createErrorAlert('❌ Products could not be added to cart. They may be sold out or unavailable.', cta);
          
          // Show sold out error on button
          cta.textContent = 'ITEMS UNAVAILABLE';
          cta.style.backgroundColor = '#dc2626';
          cta.style.color = 'white';
          cta.removeAttribute('disabled');
          inflight.delete(cta);
          
          // Reset button after 3 seconds
          setTimeout(() => {
            cta.textContent = originalText;
            cta.style.backgroundColor = '';
            cta.style.color = '';
          }, 3000);
          
          return; // Don't proceed to checkout
        }

        // Build checkout URL
        const discount = (cta.getAttribute('data-discount-code') || '').trim();
        let checkoutUrl = '/checkout';
        
        if (discount) {
          checkoutUrl = `/discount/${encodeURIComponent(discount)}?redirect=${encodeURIComponent('/checkout')}`;
        }

        console.log('[ProPlus CTA] Redirecting to:', checkoutUrl);
        console.log('[ProPlus CTA] Cart item count:', cartData.items.length);
        
        // Small delay to ensure cart operations complete
        setTimeout(() => {
          window.location.href = checkoutUrl;
        }, 100);

      } catch (err) {
        console.error('[ProPlus CTA] Error:', err);
        console.error('[ProPlus CTA] Error details:', {
          name: err.name,
          message: err.message,
          stack: err.stack
        });
        
        // Restore button state
        cta.textContent = originalText;
        cta.removeAttribute('disabled');
        inflight.delete(cta);
        
        // Try fallback: use form-based add to cart if available
        console.log('[ProPlus CTA] Trying alternative cart add method...');
        
        try {
          // Alternative: try using the product ID directly for bundles
          const productId = cta.getAttribute('data-product-id');
          if (productId) {
            const formData = new FormData();
            formData.append('id', variantIds[0]);
            formData.append('quantity', '1');
            
            const altResponse = await fetch('/cart/add', {
              method: 'POST',
              body: formData,
              credentials: 'same-origin'
            });
            
            if (altResponse.ok) {
              console.log('[ProPlus CTA] Alternative method succeeded');
              window.location.href = checkoutUrl || '/checkout';
              return;
            }
          }
        } catch (altErr) {
          console.log('[ProPlus CTA] Alternative method also failed:', altErr);
        }
        
        // Final fallback: redirect to checkout (items might be in cart already)
        console.log('[ProPlus CTA] Final fallback: redirecting to checkout');
        window.location.href = '/checkout';
      }
    },
    { capture: true }
  );

  // Section reload handlers
  document.addEventListener('shopify:section:load', () => {});
  document.addEventListener('shopify:section:select', () => {});
})();